import {Injectable, signal} from '@angular/core';
import {MsalService} from '@azure/msal-angular';
import {UserService} from './user.service';
import {OdooService} from './odoo.service';
import {ApiService} from './api.service';
import {environment} from '@env/environment';
import {EventType, InteractionRequiredAuthError} from '@azure/msal-browser';
import {Observable, from, of, throwError} from 'rxjs';
import {switchMap, tap, catchError} from 'rxjs/operators';
import {Router} from '@angular/router';
import { HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {ErrorContent} from '../models/output.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  isLoggedIn = signal(false);

  constructor(
    private msalService: MsalService,
    private userService: UserService,
    private odooService: OdooService,
    private router: Router
  ) {}


  initialize(): Observable<boolean> {
    if (this.isLoggedIn()) {
      return of(true);
    }
    return this.msalService.initialize().pipe(
      switchMap(() => from(this.msalService.instance.handleRedirectPromise())),
      switchMap(authResult => {
        const account = authResult?.account || this.msalService.instance.getActiveAccount();
        if (account) {
        this.odooService.setSessionId(account.idToken + "")
          if (!environment.production) console.log('Active Account found:', account)
          this.msalService.instance.setActiveAccount(account);
          this.userService.setUsername(account);
          this.isLoggedIn.set(true);
          return of(true)
        } else {
          this.userService.clearUsername();
          this.isLoggedIn.set(false);
          return of(false);
        }
      }),
      tap(() => {
        this.msalService.instance.addEventCallback((event) => {
          if (event.eventType === EventType.LOGIN_FAILURE) {
            if (event.error instanceof InteractionRequiredAuthError) {
              this.loginRedirect();
            }
          }
        });
      }),
      catchError(error => {
        console.error('Auth initialization error:', error);
        this.isLoggedIn.set(false);
        return of(false);
      })
    );
  }

  loginRedirect(): void {
    this.msalService.loginRedirect();
  }

  logout() {
    this.odooService.clearSessionId();
    this.msalService.logoutRedirect();
    this.userService.clearUsername();
    this.isLoggedIn.set(false);
    this.router.navigate(['/login']);
  }

  getRefreshToken(request: HttpRequest<any>, next: HttpHandlerFn, error: ErrorContent) {
    const account = this.msalService.instance.getAllAccounts()[0];
    if (account) {
      const silentRequest = {
        scopes: ["openid", "profile", "User.Read"], // i tuoi scope
        account: account,
        forceRefresh: true
      };
      return from(this.msalService.instance.acquireTokenSilent(silentRequest)).pipe(
        switchMap((response) => {
          this.odooService.setSessionId(response.idToken);
          const newRequest = request.clone({
            setHeaders: {
              Authorization: `Bearer ${response.idToken}` // o response.accessToken
            }
          });
          return next(newRequest);
        }),
        catchError((err) => {
          this.msalService.instance.clearCache().then(() => {
            this.router.navigate(['/login']).then();
          });
          return throwError(() => err);
        })
      );
    }
    return throwError(() => error);
  }

}
